<template>
  <div class="bg-block rounded -m-8 -m-12 left-gradient-block-layout">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "LeftGradientBlockLayout"
}
</script>

<style>
.left-gradient-block-layout {
  width: 820px;
}
</style>